// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"567":"120288b2b598bf5d","930":"5eae59c30e3432f9"}[chunkId] + ".js";
};